module.exports = __webpack_public_path__ + "static/media/Noirden-Thin-oblique.35f33f72.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Noirden-Thin-oblique.eot
// module id = 2879
// module chunks = 71